import React from 'react';
import TimePicker from './TimeRangePicker/TimePicker';
import TimePickerLabel from './TimeRangePicker/TimePickerLabel';

function TimeRangePickerField({ nameFrom, nameTo }) {
  return (
    <div className="time__range">
      <TimePickerLabel id={nameFrom}>Od</TimePickerLabel>
      <TimePicker name={nameFrom} />
      <span className="timepicker__gap">—</span>
      <TimePicker name={nameTo} />
      <TimePickerLabel id={nameTo}>Do</TimePickerLabel>
    </div>
  );
}

export default TimeRangePickerField;
